import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MibLogo } from '../mib-header/mib-logo';
import { CopyrightAndLegalLink } from '../copyright-and-legal-link';

/**
 * Full-screen placeholder shown once the session has ended (disconnected state).
 *
 * Reuses the waiting screen's visual language: centered Medinbox AI branding, a
 * short message with a link back to medinbox.com, the animated Medinbox diagram
 * and a copyright footer.
 */
@Component({
  selector: 'app-session-terminated',
  imports: [MibLogo, CopyrightAndLegalLink],
  templateUrl: './session-terminated.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col items-center' },
})
export class SessionTerminated {}
